let options = {
  scale: 0.92,
  durationDown: 200,
  durationUp: 340,
  timingFunctionDown: 'cubic-bezier(0.4, 0, 0.2, 1)',
  timingFunctionUp: 'cubic-bezier(0, 0, 0.2, 1)',
};

export default class Feedback {
  constructor(el) {
    this.el = el;
    this.originTransform = window.getComputedStyle(this.el, null)['transform'];
    if (this.originTransform.includes('matrix')) {
      try {
        const matrix = this.originTransform
          .replace(/matrix\(|\)|\s+/g, '')
          .split(',')
          .map((item, index) => {
            if (index === 0 || index === 3) {
              return item * options.scale;
            }
            return +item;
          })
          .join(',');
        // 计算缩小后的按压transform
        this.matrix = `matrix(${matrix})`;
      } catch (error) {
        console.error('Feedback:计算matrix异常', error);
      }
    }
    this.addEventListener(el);
  }
  addEventListener(el) {
    el.addEventListener('touchstart', this.handleAddStyles.bind(this));
    el.addEventListener('touchend', this.handleTouchEnd.bind(this));
    el.addEventListener('touchcancel', this.handleTouchEnd.bind(this));
    el.addEventListener('transitionend', this.handleTransitionend);
  }
  handleAddStyles(event) {
    event.stopPropagation();
    let el = event.currentTarget;
    el._feedbackStart = Date.now();
    el.style.transformOrigin = 'center center';
    el.style.transition = `transform ${options.durationDown}ms ${options.timingFunctionDown}`;
    el.style.transform =
      this.matrix ||
      `scale3d(${options.scale},${options.scale},${options.scale})`;
  }

  handleTouchEnd(event) {
    event.stopPropagation();
    let el = event.currentTarget;
    //点击过快的时候，需要至少运行到动画的40%才能做阻断恢复动画
    // const deltaTime = options.durationDown * 0.4 - (Date.now() - el._feedbackStart);
    const deltaTime =
      options.durationDown * 0.85 - (Date.now() - el._feedbackStart);
    // const deltaTime = 0;
    deltaTime > 0
      ? setTimeout(() => {
          this.handleRemoveStyles(el);
        }, deltaTime)
      : this.handleRemoveStyles(el);
  }
  handleRemoveStyles(el) {
    el.style.transition = `transform ${options.durationUp}ms ${options.timingFunctionUp}`;
    el._isFeedbackEnd = true;
    el.style.transform = '';
  }
  handleTransitionend(event) {
    let el = event.currentTarget;
    // isFeedbackEnd为true 意味是touchend后的transition动画结束，去除元素上的style
    if (!el._isFeedbackEnd) return;
    el.style.transformOrigin = '';
    el.style.transition = '';
    el.style.transform = '';
    el._isFeedbackEnd = false;
  }
  static removeEventListener(feedback) {
    let el = feedback.el;
    el.removeEventListener('touchstart', feedback.handleAddStyles);
    el.removeEventListener('touchend', feedback.handleTouchEnd);
    el.removeEventListener('touchcancel', feedback.handleTouchEnd);
    el.removeEventListener('transitionend', feedback.handleTransitionend);
    el._feedbackStart = el._isFeedbackEnd = undefined;
  }
}
